import React from 'react';
import BaseQuestion from './BaseQuestion';
import { QUESTION_TYPES } from '../../constants/question-types';

const ALL_FILE_TYPES = ['PDF', 'DOCX', 'JPEG', 'PNG', 'XLSX', 'PPTX'];

/**
 * Question component for File Upload configuration in the form builder.
 * Lets the form creator choose which file types respondents are allowed to upload.
 */
const FileUploadQuestion = ({
    question,
    questionIndex,
    onUpdate,
    onRemove,
    onMoveUp,
    onMoveDown,
    isFirst,
    isLast,
}) => {
    const config = question.config || {};
    const selectedTypes = config.supportedFileTypes || [];

    const toggleFileType = (fileType) => {
        const newTypes = selectedTypes.includes(fileType)
            ? selectedTypes.filter((t) => t !== fileType)
            : [...selectedTypes, fileType];

        onUpdate(questionIndex, {
            config: { ...config, supportedFileTypes: newTypes },
        });
    };

    return (
        <BaseQuestion
            question={question}
            questionIndex={questionIndex}
            onUpdate={onUpdate}
            onRemove={onRemove}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            isFirst={isFirst}
            isLast={isLast}
            questionType={QUESTION_TYPES.FILE_UPLOAD}
            questionTypeLabel="File Upload"
            questionTypeIcon="📎"
        >
            <div className="mt-3 p-3 bg-light rounded border">
                <h6 className="mb-3 text-secondary">Allowed File Types</h6>
                <div className="d-flex flex-wrap gap-2">
                    {ALL_FILE_TYPES.map((type) => {
                        const selected = selectedTypes.includes(type);
                        return (
                            <button
                                key={type}
                                type="button"
                                onClick={() => toggleFileType(type)}
                                className={`btn btn-sm px-3 py-1 fw-medium ${
                                    selected
                                        ? 'btn-primary'
                                        : 'btn-outline-secondary'
                                }`}
                                style={{ borderRadius: '20px', fontSize: '0.8rem' }}
                            >
                                {selected && (
                                    <i className="fa fa-check me-1" aria-hidden="true" />
                                )}
                                {type}
                            </button>
                        );
                    })}
                </div>
                {selectedTypes.length === 0 && (
                    <p className="text-danger small mt-2 mb-0">
                        ⚠️ At least one file type must be selected.
                    </p>
                )}
                <div className="form-text mt-2">
                    Respondents will only be able to upload files of the selected types.
                </div>
            </div>
        </BaseQuestion>
    );
};

export default FileUploadQuestion;
